import styled from 'styled-components';
import colors from 'styles/colors';
import { styledScroll } from 'styles/styledScroll';

const { white, gray03, gray01, darkBlue } = colors;

export const ControllersWrap = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: row;
  margin-bottom: 32px;
`;

export const DateWrap = styled.div`
  flex-grow: 0;
  height: 96px;
`;

export const InputsWrap = styled.div`
  flex-grow: 1;
  margin: 0 0 0 1em;
  height: 96px;
`;

export const ModalWrap = styled.div`
  width: 100vw;
  height: -webkit-fill-available;
  height: -moz-available;
  height: stretch;
  background: rgba(0, 0, 0, 0.75);
  z-index: 100;
  left: 0;
  top: 0;
  position: fixed;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const ModalContainer = styled.div`
  width: 544px;
  min-height: 360px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 0;
  margin: 0 20px;
  max-height: -webkit-fill-available;
  max-height: -moz-available;
  max-height: stretch;
  background: ${white};
  border-radius: 10px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.5), 0 10px 20px rgba(0, 0, 0, 0.25);
  padding: 24px;
  transition: all 0.25s ease;

  &:hover {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.5), 0 6px 10px rgba(0, 0, 0, 0.25);
  }
`;

export const ModalHeader = styled.div`
  color: ${gray03};
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 24px;
`;

export const ModalBody = styled.div`
  color: ${gray03};
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 24px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
`;

export const ColWrap = styled.div`
  width: calc(50% - 8px);
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const FakeLabel = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: ${darkBlue};
  width: 100%;
`;

export const InfoText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${gray01};
  width: 100%;
  height: 100%;
  line-height: 1.5em;
  max-height: ${({ hasDefinedHeight }) => (hasDefinedHeight ? '86px' : 'unset')}
  overflow-Y: ${({ hasDefinedHeight }) =>
    hasDefinedHeight ? 'auto' : 'hidden'}
  padding-right:  ${({ hasDefinedHeight }) =>
    hasDefinedHeight ? '4px' : 'none'}
  ${styledScroll};
`;

export const ModalButtonsWrap = styled.div`
  padding-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 292px;
`;
